$(document).ready(function () {
    const $section = $('#partners-highlight-section');
    const $host = $('#partners-highlight-host');

    if (!$host.length) {
        return;
    }

    const isLogged = !!localStorage.getItem('user_id');
    if (!isLogged) {
        $section.hide();
        $host.empty();
        return;
    }

    const hasText = function (value) {
        return value !== null && value !== undefined && String(value).trim().length > 0;
    };

    const normalizePartnerUrl = function (url) {
        if (!hasText(url)) {
            return null;
        }

        if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0 || url.indexOf('/') === 0) {
            return url;
        }

        return `/${url}`;
    };

    const normalizePartnerList = function (result) {
        if (Array.isArray(result)) {
            return result;
        }

        if (result && Array.isArray(result.data)) {
            return result.data;
        }

        if (result && result.data && Array.isArray(result.data.data)) {
            return result.data.data;
        }

        return [];
    };

    const normalizePartnerDescription = function (value) {
        if (!hasText(value)) {
            return null;
        }

        const cleaned = String(value)
            .replace(/<[^>]*>/g, ' ')
            .replace(/&nbsp;/gi, ' ')
            .replace(/\u00a0/g, ' ')
            .trim();

        return cleaned.length ? cleaned : null;
    };

    const renderPartners = function (partners) {
        const totalPartners = Array.isArray(partners) ? partners.length : 0;
        const desktopSlidesToShow = 3;
        const tabletSlidesToShow = 2;
        const hasDesktopOverflow = totalPartners > desktopSlidesToShow;
        const hasTabletOverflow = totalPartners > tabletSlidesToShow;
        const hasMobileOverflow = totalPartners > 1;
        const centerDesktop = totalPartners > 0 && totalPartners < desktopSlidesToShow;

        const cards = partners.map((partner) => {
            const image = hasText(partner.image_url) ? partner.image_url : null;
            const description = normalizePartnerDescription(partner.description);
            const title = hasText(partner.name) ? partner.name : 'Parceiro';
            const partnerUrl = normalizePartnerUrl(partner.url);
            const target = ' target="_blank" rel="noopener noreferrer"';
            const cardClasses = [
                'partner-highlight-link',
                partnerUrl ? '' : 'partner-highlight-link-disabled',
                image && description ? 'partner-highlight-link-split' : '',
                image && !description ? 'partner-highlight-link-image-only' : '',
                !image ? 'partner-highlight-link-text-only' : ''
            ].filter(Boolean).join(' ');

            let innerContent = '';

            if (image) {
                innerContent += `      <div class="partner-highlight-cover"><img src="${image}" alt="${title}"></div>`;
            }

            if (description) {
                innerContent += ''
                    + '      <div class="partner-highlight-content">'
                    + `          <p>${description}</p>`
                    + '      </div>';
            }

            if (!image && !description) {
                innerContent += ''
                    + '      <div class="partner-highlight-content">'
                    + '          <p>Novos parceiros serão exibidos aqui em breve.</p>'
                    + '      </div>';
            }

            if (partnerUrl) {
                return ''
                    + `<article class="partner-highlight-card" role="listitem" aria-label="${title}">`
                    + `  <a class="${cardClasses}" href="${partnerUrl}"${target}>`
                    + innerContent
                    + '  </a>'
                    + '</article>';
            }

            return ''
                + `<article class="partner-highlight-card" role="listitem" aria-label="${title}">`
                + `  <div class="${cardClasses}">`
                + innerContent
                + '  </div>'
                + '</article>';
        }).join('');

        const section = ''
            + '<section class="partners-highlight" id="partners-highlight" aria-label="Parceiros em destaque">'
            + '  <div class="partners-highlight-header">'
            + '      <h2>Parceiros em Destaque</h2>'
            + '      <div class="border"></div>'
            + '      <p>Conheça parceiros estratégicos com soluções e benefícios que impulsionam suas vendas.</p>'
            + '  </div>'
            + '  <div class="partners-highlight-carousel-wrapper">'
            + '      <div class="partners-highlight-carousel" role="list">'
            + `          ${cards}`
            + '      </div>'
            + '  </div>'
            + '</section>';

        $section.show();
        $host.html(section);

        const $carousel = $host.find('.partners-highlight-carousel');
        $carousel.toggleClass('partners-highlight-carousel--few-items', centerDesktop);

        $carousel.slick({
            dots: hasDesktopOverflow,
            arrows: hasDesktopOverflow,
            infinite: false,
            speed: 500,
            slidesToShow: desktopSlidesToShow,
            slidesToScroll: 1,
            autoplay: false,
            lazyLoad: 'ondemand',
            prevArrow: '<button class="partner-arrow partner-arrow-prev" type="button" aria-label="Parceiro anterior">&#10094;</button>',
            nextArrow: '<button class="partner-arrow partner-arrow-next" type="button" aria-label="Proximo parceiro">&#10095;</button>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: tabletSlidesToShow,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: hasTabletOverflow
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: hasMobileOverflow,
                        edgeFriction: 0.9
                    }
                }
            ]
        });
    };

    const renderEmptyState = function () {
        const emptySection = ''
            + '<section class="partners-highlight" id="partners-highlight" aria-label="Parceiros em destaque">'
            + '  <div class="partners-highlight-header">'
            + '      <h2>Parceiros em Destaque</h2>'
            + '      <p>Conheça parceiros estratégicos com soluções e benefícios que impulsionam suas vendas.</p>'
            + '  </div>'
            + '  <div class="partners-highlight-carousel-wrapper">'
            + '      <div class="partners-highlight-carousel" role="list">'
            + '          <article class="partner-highlight-card" role="listitem" aria-label="Sem parceiros cadastrados">'
            + '              <div class="partner-highlight-link partner-highlight-link-disabled">'
            + '                  <div class="partner-highlight-cover"><img src="/img/banner-galeria.jpeg" alt="Sem parceiros cadastrados"></div>'
            + '                  <div class="partner-highlight-content">'
            + '                      <h3>Em breve</h3>'
            + '                      <p>Novos parceiros serão exibidos aqui em breve.</p>'
            + '                  </div>'
            + '              </div>'
            + '          </article>'
            + '              </div>'
            + '      </div>'
            + '  </div>'
            + '</section>';

        $section.show();
        $host.html(emptySection);
    };

    const buildExternalPartnersUrl = function () {
        if (!window.api_url || !hasText(window.api_url)) {
            return null;
        }

        const baseUrl = window.api_url.endsWith('/') ? window.api_url : `${window.api_url}/`;
        if (baseUrl.indexOf('/api/') > -1) {
            return `${baseUrl}partners?active=1&per_page=30`;
        }

        return `${baseUrl}api/partners?active=1&per_page=30`;
    };

    const primaryRequest = $.ajax({
        url: '/api/partners?per_page=30',
        method: 'GET',
        dataType: 'json'
    });

    primaryRequest.done(function (result) {
        const partners = normalizePartnerList(result);

        if (!partners.length) {
            renderEmptyState();
            return;
        }
        renderPartners(partners);
    }).fail(function () {
        const externalPartnersUrl = buildExternalPartnersUrl();
        if (!externalPartnersUrl) {
            renderEmptyState();
            return;
        }

        $.ajax({
            url: externalPartnersUrl,
            method: 'GET',
            dataType: 'json',
            headers: window.$headerAuth || {}
        }).done(function (result) {
            const partners = normalizePartnerList(result);

            if (!partners.length) {
                renderEmptyState();
                return;
            }
            renderPartners(partners);
        }).fail(function () {
            renderEmptyState();
        });
    });
});
